import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Lock } from "lucide-react";
import { LOGO } from "@/data/content";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-epic-black flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO} alt="The Epic Center logo" className="w-full max-w-[280px] h-auto mx-auto object-contain" />
          <p className="text-xs tracking-[0.4em] text-epic-gold uppercase mt-2">Admin Portal</p>
        </div>
        <form onSubmit={submit} className="bg-epic-charcoal border border-white/5 p-8">
          <div className="w-12 h-12 mx-auto bg-epic-gold/10 border border-epic-gold/30 flex items-center justify-center mb-6">
            <Lock size={20} className="text-epic-gold" />
          </div>
          <label className="block text-xs uppercase tracking-[0.15em] text-white/70 mb-2">Email</label>
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full bg-transparent border border-white/15 text-white px-4 py-3 text-sm focus:outline-none focus:border-epic-gold mb-5" />
          <label className="block text-xs uppercase tracking-[0.15em] text-white/70 mb-2">Password</label>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full bg-transparent border border-white/15 text-white px-4 py-3 text-sm focus:outline-none focus:border-epic-gold" />
          {error && <p data-testid="admin-error" className="text-red-400 text-sm mt-4">{error}</p>}
          <button data-testid="admin-login-submit" disabled={loading}
            className="w-full mt-6 bg-epic-gold text-epic-black font-bold uppercase tracking-widest text-sm py-3.5 hover:bg-epic-goldhover transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" className="block text-center text-white/40 hover:text-epic-gold text-sm mt-6">← Back to site</a>
      </div>
    </div>
  );
}
